import type { CaseDefinition } from "../../domain/types/index.js";

export type AttackTrait = { id: "fatigue" | "rollback" | "action" | "hand" | "deck"; label: string };

/** 表示専用の敵設定を持たず、実際に抽選される負荷から特徴を作る。 */
export function attackTraits(spec: Pick<CaseDefinition, "loads">): AttackTrait[] {
  const loads = spec.loads.filter(load => load.weight > 0);
  const traits: AttackTrait[] = [];
  const add = (id: AttackTrait["id"], label: string, exists: boolean) => {
    if (exists) traits.push({ id, label });
  };
  add("fatigue", "疲弊", loads.some(l => (l.fatigue ?? 0) > 0));
  add("rollback", "進捗手戻り", loads.some(l => (l.progress ?? 0) < 0));
  add("action", "施策妨害", loads.some(l => l.nextActionDrawLimit != null || (l.nextEnergyModifier ?? 0) < 0));
  add("hand", "手札妨害", loads.some(l => l.nextHandDiscard != null));
  add("deck", "山札汚染", loads.some(l => l.addTemporaryCards != null));
  return traits;
}
